var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Company AP Delete","icon":"mdi-profile"}},[_c('v-container',[(_vm.formModel)?_c('smart-form',{attrs:{"schema":_vm.formSchema,"form-code":"company-apdelete"},model:{value:(_vm.formModel),callback:function ($$v) {_vm.formModel=$$v},expression:"formModel"}}):_vm._e(),_c('toolbar',{attrs:{"left-items":[{ id: 'delete', label: 'AP', onClick: _vm.deleteAP }],"right-items":[
                { label: 'Reload from QB', onClick: _vm.reloadBillsAndVendorCredits },
                { id: 'done', onClick: _vm.toListView },
            ]}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }